import LinkButton from './LinkButton';
export * from './LinkButton';
export default LinkButton;
